import { SupplierServiceModelType } from '@teinor/erp/types/company/supplier/supplierService'
import { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { ModalCreateEditLittleLoading } from '../../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../../../../baseComponents/PermissionChecker/function'
import { FormRender } from '../../../../../../../../../forms/FormRenderer/types'
import { OnSubmit } from '../../../../../../../../../forms/TwinForm/types'
import { twinFetchPostJSON } from '../../../../../../../../../utils/globals/data'
import { dictionaryComplexFromJsonArr } from '../../../../../../../../../utils/globals/dictionary'
import { valueOrDefaultValue } from '../../../../../../../../../utils/globals/valueOrDefaultValue'
import useServiceCheckUnitPrice from '../../../../../../../../../utils/hooks/service/useServiceCheckUnitPrice'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { changeErrorMessage } from '../../../../../../../../../utils/reducers/reduxDispatch'
import { SupplierServiceTypeTy } from '../../../../../../../../../specificComponents/Suppliers/types'
import { BillingRetentionPayload } from '../../../../../../../../../utils/reducers/company/billingRetentions'
import { AllReduxPayloads } from '../../../../../../../../../utils/reducers'
import { connect, ConnectedProps } from 'react-redux'
import withLoading from '../../../../../../../../../utils/hoc/withLoading'

type ModalCECreditorServiceProps = ModalEditComponentProps & ReduxModalCECreditorServiceConnector & {}

const ModalCECreditorService: React.FC<ModalCECreditorServiceProps> = ({ userPermissions, allRowData, billingRetentions, ...rest }) => {
    const { id } = useParams()
    const { t } = useTwinTranslation()
    const { checkUnitPriceAndCurrency } = useServiceCheckUnitPrice()
    const { handleOnError, serviceTypes } = useModalCECreditorServiceLogic()
    const fields: FormRender<SupplierServiceModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                },
                {
                    name: 'SupplierId',
                    component: 'InputHidden',
                    value: id
                },
                {
                    name: 'reference',
                    label: t('reference', 'Referencia'),
                    required: true,
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'ServiceTypeId',
                    label: t('expenseType', 'Tipo de gasto'),
                    component: 'CustomSelectWithSearchBar',
                    items: serviceTypes || {},
                    required: true
                },
                {
                    name: 'BillingRetentionId',
                    label: t('retentionType', 'Tipo de retención'),
                    component: 'CustomSelectWithSearchBar',
                    items: billingRetentions || {},
                },
                {
                    name: 'unitPrice',
                    label: t('unitPrice', 'Precio Unitario'),
                    component: 'InputCurrencyStateFull',
                    defaultValue: { price: allRowData?.unitPrice, CurrencyId: allRowData?.CurrencyId },
                    nameExtended: { price: 'unitPrice', CurrencyId: 'CurrencyId' },
                },
            ],
        },
    ]
    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (<ModalCreateEditLittleLoading fields={parsedFields} url={'/api/app/supplier/service/updateSupplierService'} translations={{ title: t('editService', 'Editar Servicio'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} loading={serviceTypes === null} beforeSubmit={checkUnitPriceAndCurrency}  {...rest} />)
    }

    return (<ModalCreateEditLittleLoading fields={fields} loading={serviceTypes === null} url={'/api/app/supplier/service/createSupplierService'} translations={{
        title: t('createService', 'Crear Servicio'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} beforeSubmit={checkUnitPriceAndCurrency} onChangeError={handleOnError}  {...rest} />)
}


const useModalCECreditorServiceLogic = () => {
    const { t } = useTwinTranslation()
    const errorMessage = t('referenceExists', 'La referencia ya existe')
    const [serviceTypes, setServiceTypes] = useState<SupplierServiceTypeTy | null>(null)
    const handleOnError: OnSubmit = useCallback(async (res: Response) => {
        const responseJSON = await res.json()
        if (responseJSON.errors[0].msg === 'This reference already exists') {
            changeErrorMessage(errorMessage)
        }
    }, [errorMessage])

    const getServiceTypes = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/config/serviceType/getAllServiceTypes', {})
        if (result) {
            setServiceTypes(dictionaryComplexFromJsonArr(result))
        }
    }, [setServiceTypes])

    useEffect(() => {
        getServiceTypes()
    }, [getServiceTypes])
    
    return { handleOnError, serviceTypes }
}

const modalCECreditorServiceDispatch = {
    setBillingRetentions: (payload: BillingRetentionPayload) => ({ type: 'CHANGE_BILLINGRETENTION', payload })
}
const mapModalCECreditorServiceConnector = (state: AllReduxPayloads) => ({ billingRetentions: state.billingRetentions })
const modalCECreditorServiceConnector = connect(mapModalCECreditorServiceConnector, modalCECreditorServiceDispatch)
type ReduxModalCECreditorServiceConnector = ConnectedProps<typeof modalCECreditorServiceConnector>
const tableBuysConnectLoading = withLoading(ModalCECreditorService, [{ fetchUrl: '/api/app/config/billingGroup/billingRetention/getAllBillingRetentions', propName: 'billingRetentions', setFunctionName: 'setBillingRetentions' }])
const ModalCECreditorServiceConnect = modalCECreditorServiceConnector(tableBuysConnectLoading)

export default ModalCECreditorServiceConnect